import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TIconBlockDesktop } from '../models';

export const IconBlockDesktop: FC<React.PropsWithChildren<TIconBlockDesktop>> = ({
    Block,
    DefaultIcon,
    children,
    iconSettings,
    styles,
}) => {
    return (
        <Block
            className={cn(styles.external, styles.iconWrapper)}
            notPadded
            styler={{ marginRight: 12 }}
        >
            {children ?? <DefaultIcon iconSettings={iconSettings} />}
        </Block>
    );
};
